"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitLeave = exports.saveLeave = exports.reSubmitLeave = exports.getLeaveById = exports.deleteLeaveById = exports.createAndSubmitLeave = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 添加
 * @param leave
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var saveLeave = exports.saveLeave = function saveLeave(leave) {
  return _api.default.request({
    url: '/oa/leave/save',
    method: 'post',
    data: leave
  });
};

/**
 * 提交
 * @param leave
 * @returns {*}
 */
var submitLeave = exports.submitLeave = function submitLeave(leave) {
  return _api.default.request({
    url: '/oa/leave/submit',
    method: 'post',
    data: leave
  });
};

/**
 * 重新提交
 * @param leave
 * @returns {*}
 */
var reSubmitLeave = exports.reSubmitLeave = function reSubmitLeave(leave) {
  return _api.default.request({
    url: '/oa/leave/reSubmit',
    method: 'post',
    data: leave
  });
};

/**
 * 创建并且提交
 * @param leave
 * @returns {*}
 */
var createAndSubmitLeave = exports.createAndSubmitLeave = function createAndSubmitLeave(leave) {
  return _api.default.request({
    url: '/oa/leave/createAndSubmit',
    method: 'post',
    data: leave
  });
};

/**
 * 删除
 * @param id
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteLeaveById = exports.deleteLeaveById = function deleteLeaveById(id) {
  return _api.default.request({
    url: '/oa/leave/delete',
    method: 'post',
    params: {
      id: id
    }
  });
};

/**
 * 获取详细
 * @param id
 * @returns {AxiosPromise}
 */
var getLeaveById = exports.getLeaveById = function getLeaveById(id) {
  return _api.default.request({
    url: '/oa/leave/getLeaveById',
    params: {
      id: id
    }
  });
};